<div class="login-page" *ngIf="!UserSignIn">
  <div class="mf-login-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-sm-6 offset-md-3 login-form">
          <div>
            <div>
              <a class="login-logo">
                <img
                  src="../../assets/images/logo-bajaj-capital.png"
                  alt="BCL"
                  width="250"
                />
              </a>
            </div>
            <div class="card">
              <div class="card-body" *ngIf="issignUp">
                <div class="tab-listing">
                  <div class="tab-list">
                    <a
                      [routerLink]="['/sign-in']"
                      [queryParams]="{ clientId: clientId }"
                      data-target="login"
                      >Login</a
                    >
                  </div>
                  <div class="tab-list">
                    <a
                      [routerLink]="['/sign-up']"
                      [queryParams]="{ clientId: clientId }"
                      data-target="sign_up"
                      class="active"
                      >Sign Up</a
                    >
                  </div>
                </div>
                <div class="tab-wrapper">
                  <div class="tab" id="sign_up" style="display: block">
                    <div class="google-login">
                      <a (click)="onGoogleSignIn()" style="cursor: pointer"
                        ><img
                          alt="Login with Google"
                          src="assets/images/google-icon.png"
                        /><span>Continue with Google</span></a
                      >
                    </div>
                    <div class="option-or">Or</div>

                    <div class="alert alert-success" *ngIf="otpsentmsg">
                      An OTP has been sent on your mobile. Please provide to
                      proceed
                    </div>

                    <div id="main_loader" *ngIf="loader">
                      <div class="loader-wrapper">
                        <div class="lds-roller">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <form class="account-form">
                      <div class="form-group">
                        <label for="">Name</label>
                        <input
                          type="text"
                          [(ngModel)]="name"
                          name="name"
                          appAlphaOnly
                          (blur)="validateName()"
                          maxlength="20"
                          class="form-control"
                          placeholder="Please enter your name" appBlockCopyPaste
                        />
                      </div>

                      <div class="form-group">
                        <label for="">Mobile Number</label>
                        <input
                          type="text"
                          [(ngModel)]="mobile"
                          name="mobile"
                          (blur)="validateMobileNumber()"
                          maxlength="10"
                          appNumericDirective
                          class="form-control"
                          placeholder="Your mobile number"
                          required
                          (ngModelChange)="MobileNumberChange($event)" appBlockCopyPaste
                        />
                        <a
                          class="red resend-btn"
                          *ngIf="getotp"
                          (click)="sendotp()"
                          style="cursor: pointer"
                        >
                          Generate OTP
                        </a>
                      </div>

                      <div class="form-group" *ngIf="showOtpField">
                        <label for="">Enter OTP for Mobile</label>
                        <input
                          type="text"
                          [(ngModel)]="otp"
                          name="otp"
                          maxlength="6"
                          (ngModelChange)="onOtpChange($event)"
                          (blur)="validateOtp()"
                          required
                          class="form-control"
                          placeholder="Enter OTP for Mobile"
                          appOtp appBlockCopyPaste
                        />
                        <span class="timer" *ngIf="isTimer">
                          Didn't receive OTP? Resend in
                          <strong style="font-size: 17px">{{
                            timeleft
                          }}</strong>
                          seconds
                        </span>
                        <div class="otp-btn" *ngIf="resendotp">
                          <a
                            class="red mt-2 d-block"
                            (click)="initiateOTPSignIn()"
                            style="cursor: pointer"
                            >Resend otp</a
                          >
                        </div>
                        <p *ngIf="otpverifyMsg" class="verify-message">
                          OTP verified
                        </p>
                      </div>

                      <div class="form-group">
                        <label for="">Email Address</label>
                        <input
                          type="email"
                          [(ngModel)]="email"
                          name="email"
                          (blur)="validateEmail()"
                          maxlength="50"
                          class="form-control"
                          placeholder="Your email ID" appBlockCopyPaste
                        />
                      </div>
                      <div class="form-group">
                        <label for="">Password</label>
                        <input
                          type="password"
                          [(ngModel)]="password"
                          name="password"
                          (blur)="validatePassword()"
                          maxlength="20"
                          class="form-control"
                          placeholder="Create your password" appBlockCopyPaste
                        />
                        <p *ngIf="signInErrorMessage" class="red mt-2 d-block">
                          {{ signInErrorMessage }}
                        </p>
                      </div>
                      <div class="text-center">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          (click)="onSignUp()"
                        >
                          Sign Up
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="card-body" *ngIf="isSignUpComplete">
                <h2>Confirm Your Account</h2>
                <form>
                  <div class="form-group">
                    <label for="">Verification Code</label>
                    <input
                      type="text"
                      [(ngModel)]="confirmationCode"
                      name="confirmationCode"
                      maxlength="6"
                      class="form-control"
                      placeholder="Email Verification Code Here" appBlockCopyPaste
                    />
                  </div>
                  <p *ngIf="signInErrorMessage" class="red mt-2 d-block">
                    {{ signInErrorMessage }}
                  </p>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="onConfirmSignUp()"
                    >
                      Confirm
                    </button>
                    <p class="red mt-2 d-block">
                      <a (click)="resendCodeForEmail()" style="cursor: pointer"
                        >Resend Code</a
                      >
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="popupModal" class="popup-overlay" *ngIf="showPopup">
  <div class="popup-content">
    <div class="popup-icon">
      <img src="../../assets/success.png" alt="Success Icon" />
    </div>
    <h2>Account created successfully!</h2>
    <p>
      Congratulations! Your account has been created. Please log in with your
      credentials to get started.
    </p>
    <button class="popup-btn" (click)="LoginGetStarted()">
      Login to get started
    </button>
  </div>
</div>
